import { useNavigate } from "react-router-dom";
import Header from "../../components/header";
import Footer from "../../components/footer";

export default function Careers() {
  const navigate = useNavigate();

  return (
    <div className="w-full min-h-screen bg-gray-50">
      <Header hideFilter={true} />
      
      {/* Hero Section */}
      <div className="w-full bg-gradient-to-r from-[#0f6abf] to-[#0a5ca8] py-16 md:py-24">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Join Our Team
            </h1>
            <p className="text-lg md:text-xl text-blue-100 max-w-2xl mx-auto">
              Build the future of academic-industry collaboration with AxionNest
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Left Sidebar */}
          <div className="lg:col-span-1">
            <div className="sticky top-4 space-y-4">
              {/* Filter Section */}
              <div className="bg-white rounded-2xl border border-gray-200 p-6 shadow-sm">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Filter</h3>
                
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Department
                    </label>
                    <select className="w-full border border-gray-300 rounded-xl p-2.5 text-sm focus:outline-none focus:border-[#0f6abf] focus:ring-1 focus:ring-[#0f6abf]/20">
                      <option>All Departments</option>
                      <option>Engineering</option>
                      <option>Product</option>
                      <option>Sales</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Job Type
                    </label>
                    <select className="w-full border border-gray-300 rounded-xl p-2.5 text-sm focus:outline-none focus:border-[#0f6abf] focus:ring-1 focus:ring-[#0f6abf]/20">
                      <option>All Types</option>
                      <option>Full Time</option>
                      <option>Part Time</option>
                      <option>Contract</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Location
                    </label>
                    <select className="w-full border border-gray-300 rounded-xl p-2.5 text-sm focus:outline-none focus:border-[#0f6abf] focus:ring-1 focus:ring-[#0f6abf]/20">
                      <option>All Locations</option>
                      <option>Remote</option>
                      <option>On-site</option>
                      <option>Hybrid</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Main Content Area */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
              <div className="p-8 text-center">
                <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <svg className="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
                  </svg>
                </div>
                
                <h2 className="text-3xl font-bold text-gray-900 mb-3">
                  No Job Openings Yet
                </h2>
                
                <p className="text-gray-600 text-lg mb-2">
                  We're currently not hiring, but we'd love to hear from you!
                </p>
                
                <p className="text-gray-500 mb-8">
                  Check back soon for exciting opportunities to grow with AxionNest
                </p>

                {/* Email Subscription */}
                <div className="bg-gradient-to-r from-[#e8f0f7] to-[#dfefff] rounded-xl p-6 mb-8">
                  <h3 className="text-lg font-semibold text-gray-900 mb-3">
                    Get Notified About Future Openings
                  </h3>
                  <p className="text-sm text-gray-600 mb-4">
                    Subscribe to our newsletter to be the first to know when we're hiring
                  </p>
                  <div className="flex gap-2">
                    <input
                      type="email"
                      placeholder="your@email.com"
                      className="flex-1 border border-gray-300 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-[#0f6abf] focus:ring-1 focus:ring-[#0f6abf]/20"
                    />
                    <button className="px-6 py-3 bg-[#0f6abf] text-white rounded-xl font-medium hover:bg-[#0a5ca8] transition-colors whitespace-nowrap">
                      Subscribe
                    </button>
                  </div>
                </div>

                {/* Info Boxes */}
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                  <div className="bg-blue-50 rounded-xl p-4 border border-blue-100">
                    <div className="text-4xl font-bold text-[#0f6abf] mb-2">100+</div>
                    <p className="text-sm text-gray-700">Team Members Worldwide</p>
                  </div>
                  <div className="bg-blue-50 rounded-xl p-4 border border-blue-100">
                    <div className="text-4xl font-bold text-[#0f6abf] mb-2">5+</div>
                    <p className="text-sm text-gray-700">Countries & Regions</p>
                  </div>
                  <div className="bg-blue-50 rounded-xl p-4 border border-blue-100">
                    <div className="text-4xl font-bold text-[#0f6abf] mb-2">2024</div>
                    <p className="text-sm text-gray-700">Established Year</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Why Join Us Section */}
            <div className="mt-8 bg-white rounded-2xl border border-gray-200 shadow-sm p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Why Join Us?</h3>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {[
                  {
                    title: "Collaborative Culture",
                    description: "Work with brilliant minds across academia and industry"
                  },
                  {
                    title: "Growth Opportunities",
                    description: "Continuous learning and professional development"
                  },
                  {
                    title: "Flexible Work",
                    description: "Remote and flexible working arrangements"
                  },
                  {
                    title: "Competitive Package",
                    description: "Competitive salary and comprehensive benefits"
                  },
                  {
                    title: "Impact",
                    description: "Build technology that bridges academia and industry"
                  },
                  {
                    title: "Work-Life Balance",
                    description: "We value your time and well-being"
                  }
                ].map((item, index) => (
                  <div key={index} className="flex gap-4">
                    <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center flex-shrink-0">
                      <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-1">{item.title}</h4>
                      <p className="text-sm text-gray-600">{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
